import { toast } from "sonner";
import { MessageCircle, Facebook, Twitter, Link2, Share2 } from "lucide-react";

const SHARE_TEXT =
  "ElderCare24 — caring home visits for elderly parents in Jaipur: health checks, medicines, emergency help & a live call to you. ";

export const ShareBar = () => {
  const url = typeof window !== "undefined" ? window.location.origin : "https://eldercare24.com";
  const enc = encodeURIComponent;
  const links = {
    whatsapp: `https://wa.me/?text=${enc(SHARE_TEXT + url)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`,
    twitter: `https://twitter.com/intent/tweet?text=${enc(SHARE_TEXT)}&url=${enc(url)}`,
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied — paste it anywhere!");
    } catch {
      toast.error("Could not copy the link.");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "ElderCare24", text: SHARE_TEXT, url });
      } catch {
        /* user cancelled */
      }
    } else {
      copy();
    }
  };

  const btn =
    "inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-transform active:scale-95";

  return (
    <div data-testid="share-bar" className="mb-14 rounded-3xl bg-white/5 border border-white/10 p-6 sm:p-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
        <div>
          <p className="font-serif text-2xl text-brand-cream flex items-center gap-2">
            <Share2 size={20} className="text-brand-gold" /> Share ElderCare24
          </p>
          <p className="text-sm text-brand-cream/60 mt-1">
            Know a family whose parents are in Jaipur? Pass it on — it takes a second.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <a href={links.whatsapp} target="_blank" rel="noreferrer" data-testid="share-whatsapp" className={`${btn} bg-[#25D366] text-white`}>
            <MessageCircle size={16} /> WhatsApp
          </a>
          <a href={links.facebook} target="_blank" rel="noreferrer" data-testid="share-facebook" className={`${btn} bg-[#1877F2] text-white`}>
            <Facebook size={16} /> Facebook
          </a>
          <a href={links.twitter} target="_blank" rel="noreferrer" data-testid="share-twitter" className={`${btn} bg-brand-cream text-brand-ink`}>
            <Twitter size={16} /> X
          </a>
          <button onClick={copy} data-testid="share-copy" className={`${btn} bg-white/10 text-brand-cream hover:bg-white/20`}>
            <Link2 size={16} /> Copy link
          </button>
          <button onClick={nativeShare} data-testid="share-native" className={`${btn} bg-brand text-white hover:bg-brand-hover sm:hidden`}>
            <Share2 size={16} /> Share
          </button>
        </div>
      </div>
    </div>
  );
};
